module.exports = __webpack_public_path__ + "static/media/IMG_1036.ab3e7847.jpg";